module.exports = __webpack_public_path__ + "img/re.dc807bdc.svg";